export const environment = {
  api_url: 'https://pp.api.impekkable.com',
};
